import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion } from '@ff-os/shared-react/components/accordion/Accordion';
import { AccordionField } from '@ff-os/shared-react/components/accordion/partials/AccordionField';
import { AccordionMenu } from '@ff-os/shared-react/components/accordion/partials/AccordionMenu';
import { AccordionPreviewImage } from '@ff-os/shared-react/components/accordion/partials/AccordionPreviewImage';
import { useToggle } from '@ff-os/shared-react/hooks/useToggle';
import { EngravingInputOptionGrid } from './EngravingInputOptionGrid';

export const EngravingInputControlAccordion = ({
    name, variableIds,
    selectedAssetUrl,
    shouldDisplayIcon, openByDefault,
    isContentFirst
}: Props) => {

    const [isOpen, toggleOpen] = useToggle(openByDefault);
    const showIcon = shouldDisplayIcon && selectedAssetUrl;
    const { t } = useTranslation();

    return (
        <Accordion>
            <AccordionField onClick={toggleOpen} active={isOpen}>
                {showIcon && <AccordionPreviewImage src={selectedAssetUrl} />}
                {t(name)}
            </AccordionField>
            <AccordionMenu active={isOpen} maxHeight={isContentFirst ? 'none' : 360}>
                <EngravingInputOptionGrid variableIds={variableIds} />
            </AccordionMenu>
        </Accordion>
    );
};

type Props = {
    name: string;
    variableIds: string[];
    selectedAssetUrl: string;
    openByDefault: boolean;
    shouldDisplayIcon: boolean;
    isContentFirst: boolean;
};